import './spinner.less';

import * as React from 'react';
import { InlineSpinner } from './inline-spinner';

interface ISpinnerProps {
    show: boolean;
}

const Spinner: React.FC<ISpinnerProps> = ({ show }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="tc-spinner-host ui-spinner">
            <InlineSpinner size={70} className="ts-spinner" />
        </div>
    );
};

export { Spinner };
export * from './inline-spinner';
